// extracted by mini-css-extract-plugin
export default {"floatBall":"debug_panel-module--floatBall--530ga","footer":"debug_panel-module--footer--yJc3D","fetchTime":"debug_panel-module--fetchTime--9ius7"};